module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"filterValue":"Filtrer les lignes qui ont la même valeur dans cette colonne","showFullValue":"Afficher la valeur entière"},"en":{"filterValue":"Filter the lines that have the same value in this column","showFullValue":"Show full value"}}')
  delete Component.options._Ctor
}
